import { render } from "./index.vue?vue&type=template&id=127cce54&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=127cce54&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127cce54"]])

export default __exports__